import { useAuth } from '@/contexts/AuthContext';
import {
  PaywallToggleCard,
  DemoModeCard,
  ScoutAccessCard,
  BetaPricingCard,
  TrialEmailAuditCard,
  PlaidWebhookSwitchCard,
} from '@/components/campaign';
import { SettingsScopeSection } from './SettingsScopeSection';
import { ConsultantsCard } from './ConsultantsCard';

/**
 * The "Admin" scope band on the Settings hub — platform-ops tools (paywall, demo
 * mode, Scout access, beta pricing, trial audit, the Plaid webhook switch, Consultants).
 *
 * Gated at the section level on `user.isPlatformAdmin`: a non-admin sees nothing
 * (no header, no cards) and — because the cards never mount — triggers no admin
 * fetches (notably `TrialEmailAuditCard`'s audit query). Each card also keeps its
 * own `isPlatformAdmin` guard as defense-in-depth.
 *
 * The finance-reset control is NOT here: it's gated on the campaign's `isDemo`
 * flag (reachable by non-admin demo members), so it lives in `DemoControlsSection`.
 */
export function AdminSection() {
  const { user } = useAuth();

  if (!user?.isPlatformAdmin) return null;

  return (
    <SettingsScopeSection title="Admin" description="Platform administration">
      <div className="space-y-4">
        <PaywallToggleCard />
        <DemoModeCard />
        <ScoutAccessCard />
        <BetaPricingCard />
        <TrialEmailAuditCard />
        <PlaidWebhookSwitchCard />
        <ConsultantsCard />
      </div>
    </SettingsScopeSection>
  );
}
